import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useState } from "react";
import { NoOutlineSelect } from "../../NoOutlineSelect";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { Box, ListItemText, MenuItem, Tooltip } from "@mui/material";
import { debounce } from "lodash";
export const speedValues = [0.8, 0.9, 1, 1.1, 1.2];
export const SpeedSelection = ({ speedValue, onSpeedClick }) => {
    // Handle MUI bug where tooltips remain open after interacting with a Select component
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const debouncedSetTooltipOpen = useCallback(debounce(setTooltipOpen, 300), []);
    const closeTooltip = useCallback(() => {
        setTimeout(() => {
            debouncedSetTooltipOpen(false);
            debouncedSetTooltipOpen.flush();
        }, 0);
    }, []);
    const changeHandler = (newValue) => {
        if (onSpeedClick) {
            onSpeedClick(newValue);
        }
    };
    const renderedOptions = () => {
        return speedValues.map((option) => (_jsxs(MenuItem, { value: option, dense: true, selected: option === speedValue, onClick: () => changeHandler(option), children: [_jsx(ListItemText, { primary: option + "x" }), option === speedValue && _jsx(FontAwesomeIcon, { fontSize: "16px", icon: faCheck })] }, option)));
    };
    return _jsx(Tooltip, { title: "Speed", placement: "top", arrow: true, open: tooltipOpen, children: _jsx(Box, { children: _jsx(NoOutlineSelect, { "data-testid": "testid-speed-selection", size: "small", value: speedValue, MenuProps: {
                    sx: { ".MuiMenu-list": { width: "75px" } },
                    transformOrigin: { horizontal: "left", vertical: "top" },
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    disableAutoFocus: true
                }, renderValue: (value) => (value + "x"), "data-tracking-id": "tracking-id-vo-ph-speed-btn", onMouseEnter: () => debouncedSetTooltipOpen(true), onMouseLeave: closeTooltip, onOpen: closeTooltip, children: renderedOptions() }) }) });
};
//# sourceMappingURL=SpeedSelection.js.map